import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import ListData from 'components/Details/ListData';
import { displayTime } from 'utils/time';
import { assetStatus } from 'utils/constants/assetText';
import { assignedAssetColumns } from './options';
import styles from './index.module.scss';
import { getSelectedAssetData } from './helper';
import { assetPageSpecificActions } from 'containers/Pages/Assets/Assets';
import { t } from 'i18next';
import { getAssetCategoryData } from 'utils/helper/assetType';

const ShowAssignedAssets = ({
  assignedAssets,
  personnelId,
  requestAssetReturn,
  assignee,
}) => {
  const getListData = assignedAssets => {
    if (assignedAssets.length > 0) {
      return assignedAssets.map(asset => ({
        assetId: asset.assetId,
        assetName: asset.name,
        category: getAssetCategoryData(asset.type.category),
        lastStatusUpdated: displayTime({
          timestamp: asset.currentStatusTimestamp,
        }),
        currentStatus: getDataToShowStatus(asset),
      }));
    } else {
      return [];
    }
  };
  const getDataToShowStatus = asset => {
    if (asset.currentStatus === assetStatus.IN_USE) {
      return {
        type: 'button',
        btnData: {
          text: 'REQUEST',
          color: 'primary',
          className: styles.listBtn,
          onClick: requestAssetReturnHandler,
        },
        itemData: {
          id: asset.id,
        },
      };
    } else {
      return {
        type: 'text',
        data: asset.currentStatus,
      };
    }
  };

  const requestAssetReturnHandler = assetId => {
    const selectedAssetData = getSelectedAssetData(assignedAssets, assetId);
    requestAssetReturn({
      ...selectedAssetData,
      assetAssigneeId: personnelId,
      assignee: { firstName: assignee.firstName, lastName: assignee.lastName },
    });
  };
  return (
    <>
      <label className={styles.label}>{t('Assigned Assets')} </label>
      <ListData
        col={assignedAssetColumns}
        data={getListData(assignedAssets)}
        className={styles.listData}
      />
    </>
  );
};

ShowAssignedAssets.propTypes = {
  assignedAssets: PropTypes.array.isRequired,
  personnelId: PropTypes.string,
  assignee: PropTypes.object,
  requestAssetReturn: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  requestAssetReturn: ({ assetAssigneeId, id, assetId, name, assignee }) =>
    dispatch(
      assetPageSpecificActions.requestAssetReturn({
        assetAssigneeId,
        id,
        assetId,
        name,
        assignee,
      }),
    ),
});

export default connect(null, mapDispatchToProps)(ShowAssignedAssets);
